<script>
  import store from '~/Library/store'
  import {fly, fade} from 'svelte/transition'
  import OfferModalMolecule from '~/Components/Molecules/OfferModal'
  import MentorModalMolecule from '~/Components/Molecules/MentorModal'

  const modals = {
    mentors: MentorModalMolecule, 
    personal: OfferModalMolecule, 
    career: OfferModalMolecule
  }

  function changeCards(adjustment){
    const currentCardIndex = $store.card_index 
    const lengthOfCards = $store.data.cards.length
    let nextCardIndex = currentCardIndex+adjustment

    if(nextCardIndex >= lengthOfCards){
      nextCardIndex = 0
    } else if(nextCardIndex < 0){
      nextCardIndex = (lengthOfCards-1)
    } 
    store.setAttribute('card_index', nextCardIndex)
  }
  
</script>

<div class="overlay" transition:fade="{{duration: 500}}" on:click={() => store.setAttribute('card_index', -1)}>
  {#if $store.card_index > -1}
    <img src="/static/icons/arrow-left.svg" transition:fly="{{ x: -100, duration: 500 }}" on:click|stopPropagation alt="" class="modal__nav" on:click={ () => changeCards(-1)}>
    <div class="modal" transition:fly="{{ y: 400, duration: 500 }}">
      <img src="/static/icons/close-modal.svg" alt="" class="modal__close">
      <svelte:component this={modals[$store.card_type]} card={$store.data.cards[$store.card_index]} />
    </div>
    <img src="/static/icons/arrow-right.svg" transition:fly="{{ x: 100, duration: 500 }}" on:click|stopPropagation alt="" class="modal__nav" on:click={ () => changeCards(1)}>
  {/if}
</div>

<style lang="scss">
 // Empty 
</style>